module.exports = __webpack_public_path__ + "img/dummyprod2@2x.311586fd.png";